import { AxiosInstance, AxiosRequestConfig } from 'axios'

import {
  ApiClient,
  anonIdInterceptor,
  csrfTokenInterceptor,
} from '@marketplace-web/core-api/api-client-util'

import { NEXT_HEADERS } from '@marketplace-web/vendor-abstractions/http-client-util/server'
import { serverEnvs } from '@marketplace-web/environment/environment-util/server'

import { ApiGatewayType, PLATFORM_HEADER_KEY } from './constants'
import { isoLocaleInterceptor } from './interceptors/iso-locale-interceptor'
import { resolveApiGatewayUrl } from './utils/resolve-api-gateway-url'

export class ApiGatewayClient extends ApiClient {
  constructor(
    config: AxiosRequestConfig & { type?: ApiGatewayType } = {},
    interceptors: Array<((instance: AxiosInstance) => void) | undefined> = [],
  ) {
    super(
      {
        baseURL: resolveApiGatewayUrl(config.type || ApiGatewayType.Default),
        withCredentials: true,
        headers: {
          [PLATFORM_HEADER_KEY]: 'web',
          [NEXT_HEADERS.X_NEXT_APP]: serverEnvs.SERVICE_NAME ?? 'marketplace-web',
        },
        ...config,
      },
      [...interceptors, csrfTokenInterceptor, anonIdInterceptor, isoLocaleInterceptor],
    )
  }
}
